const H = {
  name: "QrCode",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 4H4V7H7V4Z" fill="currentColor"/>
<path d="M11 0H0V11H11V0ZM2 9V2H9V9H2Z" fill="currentColor"/>
<path d="M17 4H20V7H17V4Z" fill="currentColor"/>
<path d="M24 0H13V11H24V0ZM15 9V2H22V9H15Z" fill="currentColor"/>
<path d="M4 17H7V20H4V17Z" fill="currentColor"/>
<path d="M0 13H11V24H0V13ZM2 15V22H9V15H2Z" fill="currentColor"/>
<path d="M15 13H13V15H15V17H13V22H15V24H17V22H22V24H24V22H22V17H24V15H22V13H17V15H15V13ZM19 17V15H22V17H19ZM17 19V17H19V19H17ZM17 19V22H15V19H17Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as QrCode
};
